module.exports = __webpack_public_path__ + "public/img/hubvet_logo_hex.10b2fb7e.svg";